/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the about us section of organizations.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import { OrganizationEmptyBoxPlaceholder } from '~/jobiqo/components/Organization/Widgets/OrganizationBoxPlaceholder';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { AddIcon } from '~/vcl/icons/Add';
import { OfficeIcon } from '~/vcl/icons/Office';

interface OrganizationAboutWidgetEmptyProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

export const OrganizationAboutWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationAboutWidgetEmptyProps) => {
  const intl = useIntl();

  return (
    <Box>
      <OrganizationEmptyBoxPlaceholder
        organization={organization}
        field={boxId}
        text={intl.formatMessage({
          id: 'organization_about_empty_text',
          defaultMessage: `Enter your organization presentation here. you can edit this description
            in a formatted way so that applicant's know more about the organization.`,
        })}
        buttonText={intl.formatMessage({
          id: 'organization_about_empty_enter',
          defaultMessage: `Enter presentation`,
        })}
        icon={<OfficeIcon title="Preferences" />}
        buttonIcon={<AddIcon title="briefcase" />}
      />
    </Box>
  );
};
